import type { PartyType } from '@/typings/bill'
import { t } from '@/plugins/i18n'

/** 地址类型常量 */
export const PARTY_TYPES = {
  /** 收货人 */
  CO: 'CO',
  /** 发货人 */
  SN: 'SN',
  /** 买方 */
  BY: 'BY',
  /** 卖方 */
  SE: 'SE',
  /** 申报人 */
  DT: 'DT',
  /** 通知人 */
  NO: 'NO',
  /** 承运人 */
  CR: 'CR',
} as const

/** 地址类型标签映射 */
export const PARTY_TYPE_LABELS: Record<PartyType, string> = {
  CO: t('partyType.CO'),
  SN: t('partyType.SN'),
  BY: t('partyType.BY'),
  SE: t('partyType.SE'),
  DT: t('partyType.DT'),
  NO: t('partyType.NO'),
  CR: t('partyType.CR'),
}

/** 地址类型选项列表 */
export const PARTY_TYPE_OPTIONS = Object.entries(PARTY_TYPE_LABELS).map(
  ([value, label]) => ({
    value,
    label,
  }),
) as { value: PartyType; label: string }[]

export default PARTY_TYPES
